
import { useState, useEffect } from "react";
import { isOnline } from "@/utils/connectionUtils";
import { showReconnectedToast } from "../utils/chatNetworkUtils";

export const useOnlineStatus = (networkError: boolean, lastMessage: string) => {
  useEffect(() => {
    let checkInterval: number;
    
    if (networkError) {
      checkInterval = window.setInterval(() => {
        if (isOnline()) {
          if (lastMessage) {
            showReconnectedToast();
          }
          clearInterval(checkInterval);
        }
      }, 5000);
    }
    
    return () => {
      if (checkInterval) clearInterval(checkInterval);
    };
  }, [networkError, lastMessage]);
};
